/* eslint-disable import/prefer-default-export */

export const DATASET_FIELD_DISPLAY = {
  LOC: 'Locations / Business Units',
  TRAN: 'Transaction Date',
  QTY: 'Quantity',
  PPU: 'Price',
  TTP: 'Price',
};
